import React, { useMemo } from "react";
import cn from "classnames";
import { useAppState } from "hooks/AppContext";
import { useEmployeeModal } from "hooks/useEmployeeModal";
import { EmployeeCard } from "./EmployeeCard";
import { EmployeeStoryModal } from "./EmployeeStoryModal";
import styles from "./EmployeeCardList.module.scss";

export type EmployeeCardListProps = {
    title?: string;
    viewMore?: React.ReactNode;
} & React.HTMLProps<HTMLElement>;

export const EmployeeCardList = ({
    className,
    title,
    viewMore,
    ...props
}: EmployeeCardListProps) => {
    const { employeeStories } = useAppState();
    const storiesList = useMemo(() => employeeStories.slice(0, 3), [employeeStories]);
    const employeeModal = useEmployeeModal({ employeeStories: storiesList });

    return storiesList.length ? (
        <>
            <section className={cn(styles.wrapper, className)} {...props}>
                {!!title && <h2 className={styles.heading}>{title}</h2>}
                <div className={styles.cardList}>
                    {storiesList.map((employee) => (
                        <EmployeeCard
                            employee={employee}
                            onClick={() => employeeModal.setOpenStory(employee.id)}
                            key={employee.id}
                        />
                    ))}
                </div>
                {viewMore}
            </section>
            <EmployeeStoryModal
                employee={employeeModal.openStory}
                isOpen={employeeModal.isOpen}
                setIsOpen={employeeModal.setIsOpen}
            />
        </>
    ) : <textarea readOnly value={JSON.stringify(storiesList || "")} />;
};
